import { Inject, Pipe, PipeTransform } from "@angular/core";
import { ASSET_ROOT_URL } from "./asset-url.providers";

@Pipe({ pure: true, name: "assetUrl", standalone: false })
export class AssetUrlPipe implements PipeTransform {
  constructor(@Inject(ASSET_ROOT_URL) private assetRootUrl: string) {}

  transform(input: string): string {
    return `${this.assetRootUrl}/${input}`;
  }
}
